export default __webpack_public_path__ + "static/media/ShiftRequirement.d63e2574.svg";